module.exports = __webpack_public_path__ + "static/media/star.e9de287e.svg";